import { render, staticRenderFns } from "./RevendaHero.vue?vue&type=template&id=ccec90b0&scoped=true"
import script from "./RevendaHero.vue?vue&type=script&lang=js"
export * from "./RevendaHero.vue?vue&type=script&lang=js"
import style0 from "./RevendaHero.vue?vue&type=style&index=0&id=ccec90b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccec90b0",
  null
  
)

export default component.exports